import React from "react";

/**
 * Kit hero header — the very first thing the customer sees when their kit
 * loads. Pure presentational; the heavy lifting (HowToUse, ProgressBar, etc.)
 * lives in Kit.jsx and renders below this block.
 *
 * Kept deliberately small (~12 lines of JSX) so the brand voice is easy to
 * tweak without touching the rest of the page logic.
 */
export const IntroBlock = ({ cafe, igHandle }) => (
    <header className="text-center mb-12 sm:mb-16" data-testid="kit-intro-block">
        <p className="text-[10px] uppercase tracking-[0.3em] text-cafe-olive font-semibold mb-3">
            30-day visual content kit
        </p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-cafe-espresso leading-[1.05] mb-3">
            Your <em className="font-display italic text-cafe-olive">Instagram</em>
            <br />
            for the next 30 days.
        </h1>
        <p className="text-cafe-mocha text-sm sm:text-base max-w-xl mx-auto">
            Made for <strong className="text-cafe-espresso">{cafe}</strong>
            {igHandle ? (
                <>
                    {" "}· <span className="text-cafe-olive">@{igHandle}</span>
                </>
            ) : null}
            .
        </p>
    </header>
);
